module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab12/awsop-lab12.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab12/awsop-lab12.component.css
// module chunks = main